import { CallUsTemplate } from '@templates';
import { RoutesList } from '../../../routes/Routes';
import { useNavigate } from 'react-router-dom';
import { Link } from '@atoms/*';
import { Details, EvCallUsDetailsContent } from '@molecules/index';

const ContentBody = () => (
  <div className="text-bodyLg flex flex-col gap-4">
    <div>
      <p>
        <strong>Phone</strong>:{` `}020 7641 2000
      </p>
      <p>24-hour service</p>
      <p>
        Standard call charges apply. Visit{' '}
        <Link
          href="https://www.gov.uk/call-charges"
          className="text-action-link font-normal underline"
          linkType="inline"
          title="Opens in a new tab"
          external={true}
        >
          gov.uk{' '}
        </Link>
        for more information.
      </p>
    </div>
  </div>
);

export const CallUsPage = () => {
  const navigate = useNavigate();
  const title = 'Call us for immediate assistance';
  const buttonPrevious = {
    onClick: () => {
      navigate(RoutesList.IS_HAZARDOUS);
    },
  };
  const buttonNext = {
    label: 'Back to homepage',
    onClick: () => {
      window.location.href = 'https://www.westminster.gov.uk/report-it';
    },
  };
  return (
    <CallUsTemplate
      title={title}
      contentBody={<ContentBody />}
      callButton={{
        href: 'tel:+441135182215',
        label: 'Call us',
      }}
      bottomLink={
        <Details
          summary="If you have a hearing or speech impairment"
          content={<EvCallUsDetailsContent />}
        />
      }
      buttonPrevious={buttonPrevious}
      buttonNext={buttonNext}
    />
  );
};
